import React from 'react'
import { withTranslation } from 'react-i18next'

import * as IDENTITY_ACTIONS from 'app/constants/identityActions'
import Button from 'app/components/ButtonDefault/index'
import LinkButton from 'app/domains/common/LinkButton'
import { apiUrlNew } from 'app/config'
import './styles.scss'
import Facebook from 'app/components/SVGS/Facebook'
import Twitter from 'app/components/SVGS/Twitter'
import Linkedin from 'app/components/SVGS/Linkedin'
import IconButton from 'app/domains/common/IconButton'
import { isMobile } from 'react-device-detect'

export const bc = 'user-activity-control-panel-activity-actions'
// id need for focus during onbording
export const onboardingId = 'todayActivity'

export const getHash = ({ activityId, identityId }) => {
  return btoa(JSON.stringify({ activityId, userId: identityId }))
}

const openWindow = (url, target, features) => window.open(url, target, features)

const renderSocialButtons = ({ activityId, identityId, t, windowWidth }) => {
  const hash = getHash({ activityId, identityId })
  const handleOpenWindow = url => {
    return openWindow(url, '', `width=600,height=500,left=${windowWidth / 2 - 300},top=200`)
  }
  return (
    <div className={`${bc}__social-buttons-wrapper`}>
      <div className={`${bc}__social-buttons-title`}>{t('Share this action on social')}</div>
      <div className={`${bc}__social-buttons`}>
        <IconButton
          className={`${bc}__social-buttons-icon`}
          onClick={() =>
            handleOpenWindow(
              `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dfacebook`
            )
          }
        >
          <Facebook />
        </IconButton>
        <IconButton
          className={`${bc}__social-buttons-icon`}
          onClick={() =>
            handleOpenWindow(
              `https://twitter.com/intent/tweet?text=Share+My+Activity&url=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dtwitter`
            )
          }
        >
          <Twitter />
        </IconButton>
        <IconButton
          className={`${bc}__social-buttons-icon`}
          onClick={() =>
            handleOpenWindow(
              `https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dlinkedin`
            )
          }
        >
          <Linkedin />
        </IconButton>
      </div>
    </div>
  )
}

const UserActivityControlPanelActivityActions = ({
  t,
  onCommit,
  onDid,
  onDidnot,
  actions,
  isDisabled,
  activityId,
  identityId,
  windowWidth,
  isSocialActivated,
}) => {
  const canCommit = actions.has(IDENTITY_ACTIONS.COMMIT)
  const didAndDidnot = actions.has(IDENTITY_ACTIONS.DID) && actions.has(IDENTITY_ACTIONS.DIDNOT)

  const renderCommitAndTryDifferent = (t, windowWidth) => (
    <div key={'renderCommitAndTryDifferent'} className={`${bc}__wrapper`}>
      <div className={`${bc}__buttons`}>
        <Button
          primary
          onClick={() => {
            !isDisabled && onCommit()
          }}
          sm
          disabled={isDisabled}
          className={`${bc}__button`}
          id={onboardingId}
        >
          {t('I commit')}
        </Button>
        <LinkButton
          to="/different-activity/upcoming"
          sm
          disabled={isDisabled}
          style={{ fontWeight: 'normal' }}
          className={`${bc}__button`}
        >
          {t('Try different activity')}
        </LinkButton>
      </div>
      {isSocialActivated && renderSocialButtons({ activityId, identityId, t, windowWidth })}
    </div>
  )

  const renderDidAndDidnot = (t, windowWidth, isSocialActivated) => (
    <div key={'renderDidAndDidnot'} className={`${bc}__wrapper`}>
      <div className={`${bc}__buttons`}>
        <Button
          primary
          onClick={() => {
            !isDisabled && onDid()
          }}
          sm
          disabled={isDisabled}
          className={`${bc}__button`}
          id={onboardingId}
        >
          {t('I Did It')}
        </Button>
        <Button
          onClick={() => {
            !isDisabled && onDidnot()
          }}
          sm
          disabled={isDisabled}
          className={`${bc}__button`}
        >
          {t(`I Couldn't Do It`)}
        </Button>
      </div>
      {isSocialActivated && renderSocialButtons({ activityId, identityId, t, windowWidth })}
    </div>
  )

  const renderButtons = () => {
    if (canCommit) return renderCommitAndTryDifferent(t, windowWidth, isSocialActivated)
    if (didAndDidnot) return renderDidAndDidnot(t, windowWidth, isSocialActivated)
  }

  return canCommit || didAndDidnot ? renderButtons() : null
}

export default withTranslation('user')(UserActivityControlPanelActivityActions)
